import {IAppraisalTable} from "types/dealTypes";

export const HANDLE_GET_ONE_DAY_SALE_APPRAISAL = "HANDLE_GET_ONE_DAY_SALE_APPRAISAL";

export interface HandleGetOneDaySaleAppraisal {
  type: typeof HANDLE_GET_ONE_DAY_SALE_APPRAISAL;
  payload: any
}

export const GET_ONE_DAY_SALE_APPRAISAL_PENDING = "GET_ONE_DAY_SALE_APPRAISAL_PENDING";

export interface GetOneDaySaleAppraisalPending {
  type: typeof GET_ONE_DAY_SALE_APPRAISAL_PENDING;
}

export const GET_ONE_DAY_SALE_APPRAISAL_RESOLVED = "GET_ONE_DAY_SALE_APPRAISAL_RESOLVED";

export interface GetOneDaySaleAppraisalResolved {
  type: typeof GET_ONE_DAY_SALE_APPRAISAL_RESOLVED;
  payload:any;
}

export const GET_ONE_DAY_SALE_APPRAISAL_REJECTED = "GET_ONE_DAY_SALE_APPRAISAL_REJECTED";

export interface GetOneDaySaleAppraisalRejected {
  type: typeof GET_ONE_DAY_SALE_APPRAISAL_REJECTED;
  payload: object[];
}

export const HANDLE_GET_ONE_DAY_SALE_APPRAISAL_BY_ID = "HANDLE_GET_ONE_DAY_SALE_APPRAISAL_BY_ID";

export interface HandleGetOneDaySaleAppraisalById {
  type: typeof HANDLE_GET_ONE_DAY_SALE_APPRAISAL_BY_ID;
  payload: any
}

export const GET_ONE_DAY_SALE_APPRAISAL_BY_ID_PENDING = "GET_ONE_DAY_SALE_APPRAISAL_BY_ID_PENDING";

export interface GetOneDaySaleAppraisalByIdPending {
  type: typeof GET_ONE_DAY_SALE_APPRAISAL_BY_ID_PENDING;
}

export const GET_ONE_DAY_SALE_APPRAISAL_BY_ID_RESOLVED = "GET_ONE_DAY_SALE_APPRAISAL_BY_ID_RESOLVED";

export interface GetOneDaySaleAppraisalByIdResolved {
  type: typeof GET_ONE_DAY_SALE_APPRAISAL_BY_ID_RESOLVED;
  payload:any;
}

export const GET_ONE_DAY_SALE_APPRAISAL_BY_ID_REJECTED = "GET_ONE_DAY_SALE_APPRAISAL_BY_ID_REJECTED";

export interface GetOneDaySaleAppraisalByIdRejected {
  type: typeof GET_ONE_DAY_SALE_APPRAISAL_BY_ID_REJECTED;
  payload: object[];
}



export const HANDLE_UPDATE_ONE_DAY_SALE_APPRAISAL = "HANDLE_UPDATE_ONE_DAY_SALE_APPRAISAL";

export interface HandleUpdateOneDaySaleAppraisal {
  type: typeof HANDLE_UPDATE_ONE_DAY_SALE_APPRAISAL;
  payload:any;
}


export const HANDLE_CREATE_ONE_DAY_SALE_APPRAISAL= "HANDLE_CREATE_ONE_DAY_SALE_APPRAISAL";

export interface HandleCreateOneDaySaleAppraisal {
  type: typeof HANDLE_CREATE_ONE_DAY_SALE_APPRAISAL;
  payload:any;
}
//

export const HANDLE_GET_ONE_DAY_SALE_DATE = "HANDLE_GET_ONE_DAY_SALE_DATE";

export interface HandleGetOneDaySaleDate {
  type: typeof HANDLE_GET_ONE_DAY_SALE_DATE;
  payload: any
}

export const GET_ONE_DAY_SALE_DATE_PENDING = "GET_ONE_DAY_SALE_DATE_PENDING";

export interface GetOneDaySaleDatePending {
  type: typeof GET_ONE_DAY_SALE_DATE_PENDING;
}

export const GET_ONE_DAY_SALE_DATE_RESOLVED = "GET_ONE_DAY_SALE_DATE_RESOLVED";

export interface GetOneDaySaleDateResolved {
  type: typeof GET_ONE_DAY_SALE_DATE_RESOLVED;
  payload:any;
}

export const GET_ONE_DAY_SALE_DATE_REJECTED = "GET_ONE_DAY_SALE_DATE_REJECTED";

export interface GetOneDaySaleDateRejected {
  type: typeof GET_ONE_DAY_SALE_DATE_REJECTED;
  payload: object[];
}

export const HANDLE_GET_ONE_DAY_SALE_WORKBOOK = "HANDLE_GET_ONE_DAY_SALE_WORKBOOK";

export interface HandleGetOneDaySaleWorkbook {
  type: typeof HANDLE_GET_ONE_DAY_SALE_WORKBOOK;
  payload: any
}

export const GET_ONE_DAY_SALE_WORKBOOK_PENDING = "GET_ONE_DAY_SALE_WORKBOOK_PENDING";

export interface GetOneDaySaleWorkbookPending {
  type: typeof GET_ONE_DAY_SALE_WORKBOOK_PENDING;
}

export const GET_ONE_DAY_SALE_WORKBOOK_RESOLVED = "GET_ONE_DAY_SALE_WORKBOOK_RESOLVED";

export interface GetOneDaySaleWorkbookResolved {
  type: typeof GET_ONE_DAY_SALE_WORKBOOK_RESOLVED;
  payload:any;
}

export const GET_ONE_DAY_SALE_WORKBOOK_REJECTED = "GET_ONE_DAY_SALE_WORKBOOK_REJECTED";

export interface GetOneDaySaleWorkbookRejected {
  type: typeof GET_ONE_DAY_SALE_WORKBOOK_REJECTED;
  payload: object[];
}


export const HANDLE_UPDATE_ONE_DAY_SALE_DATE = "HANDLE_UPDATE_ONE_DAY_SALE_DATE";

export interface HandleUpdateOneDaySaleDate {
  type: typeof HANDLE_UPDATE_ONE_DAY_SALE_DATE;
  payload:any;
}


export const HANDLE_CREATE_ONE_DAY_SALE_DATE= "HANDLE_CREATE_ONE_DAY_SALE_DATE";

export interface HandleCreateOneDaySaleDate {
  type: typeof HANDLE_CREATE_ONE_DAY_SALE_DATE;
  payload:any;
}

/* Deals TradeIn Notes*/

export const HANDLE_SAVE_ONE_DAY_SALE_NOTES = "HANDLE_SAVE_ONE_DAY_SALE_NOTES";
export interface HandleSaveOneDaySaleNotes {
  type: typeof HANDLE_SAVE_ONE_DAY_SALE_NOTES,
  payload: any 
};

export const HANDLE_GET_ONE_DAY_SALE_NOTES = "HANDLE_GET_ONE_DAY_SALE_NOTES ";
export interface HandleGetOneDaySaleNotes {
  type: typeof  HANDLE_GET_ONE_DAY_SALE_NOTES;
  payload: any;
}


export const HANDLE_DELETE_ONE_DAY_SALE_DATE = "HANDLE_DELETE_ONE_DAY_SALE_DATE";

export interface HandleDeleteOneDaySaleDate {
  type: typeof HANDLE_DELETE_ONE_DAY_SALE_DATE;
  payload: { id: number; callback?: (res) => void };
}

export const HANDLE_GET_APPRAISAL_VEH_DETAILS = "HANDLE_GET_APPRAISAL_VEH_DETAILS";
export interface HandleGetAppraisalVehDetails {
  type: typeof HANDLE_GET_APPRAISAL_VEH_DETAILS;
  payload: any;
}

export const HANDLE_GET_APPRAISAL_TRIM_VIN = "HANDLE_GET_APPRAISAL_TRIM_VIN";
export interface HandleGetAppraisalTrimUsingVin {
  type: typeof HANDLE_GET_APPRAISAL_TRIM_VIN;
  payload: any;
}

export const HANDLE_SELECTED_ONEDAYSALE_TRADEIN = "HANDLE_SELECTED_ONEDAYSALE_TRADEIN";

export interface HandleSelectedOneDaySaleTradeIn {
    type: typeof HANDLE_SELECTED_ONEDAYSALE_TRADEIN;
    payload: any;
}

export const GET_ONE_DAY_APPRAISAL_TABLE_LIST_PENDING = "GET_ONE_DAY_APPRAISAL_TABLE_LIST_PENDING";

export interface GetOneDayAppraisalTablePending {
  type: typeof GET_ONE_DAY_APPRAISAL_TABLE_LIST_PENDING;
}

export const GET_ONE_DAY_APPRAISAL_TABLE_LIST_RESOLVED = "GET_ONE_DAY_APPRAISAL_TABLE_LIST_RESOLVED";
export interface GetOneDayAppraisalTableResolved {
  type: typeof GET_ONE_DAY_APPRAISAL_TABLE_LIST_RESOLVED;
  payload: {results:IAppraisalTable[]};
}

export const HANDLE_GET_ONE_DAY_APPRAISAL_TABLE_LIST = "HANDLE_GET_ONE_DAY_APPRAISAL_TABLE_LIST";

export interface HandleGetOneDayAppraisalTable {
  type: typeof HANDLE_GET_ONE_DAY_APPRAISAL_TABLE_LIST;
  payload: any
}

export const GET_ONE_DAY_APPRAISAL_TABLE_LIST_REJECTED = "GET_ONE_DAY_APPRAISAL_TABLE_LIST_REJECTED";

export interface GetOneDayAppraisalTableRejected {
  type: typeof GET_ONE_DAY_APPRAISAL_TABLE_LIST_REJECTED;
  payload: object[];
}

export const HANDLE_CREATE_ONE_DAY_APPRAISAL_TABLE_LIST_ITEM = "HANDLE_CREATE_ONE_DAY_APPRAISAL_TABLE_LIST_ITEM";

export interface HandleCreateOneDayAppraisalTableItem {
  type: typeof HANDLE_CREATE_ONE_DAY_APPRAISAL_TABLE_LIST_ITEM;
  payload:any;
}

export const HANDLE_CREATE_ONE_DAY_SALE_DEAL_RECORD = "HANDLE_CREATE_ONE_DAY_SALE_DEAL_RECORD";

export interface HandleCreateOneDaySaleDealRecord {
    type: typeof HANDLE_CREATE_ONE_DAY_SALE_DEAL_RECORD;
    payload:any;
}

export const HANDLE_SEARCH_ONE_DAY_SALE_DEAL_RECORD = "HANDLE_SEARCH_ONE_DAY_SALE_DEAL_RECORD";

export interface HandleSearchOneDaySaleDealRecord {
    type: typeof HANDLE_SEARCH_ONE_DAY_SALE_DEAL_RECORD;
    payload: { deal: any; callback: Function};
}

export const HANDLE_CREATE_APPRAISAL_FORM_VALUE = "HANDLE_CREATE_APPRAISAL_FORM_VALUE";

export interface HandleCreateAppraisalFormValue {
  type: typeof HANDLE_CREATE_APPRAISAL_FORM_VALUE;
  payload: {
    formData: any;
    callback: (id: number | null) => void;
  };
}

export const HANDLE_SHOW_ONEDAY_SALE_WARNING = "HANDLE_SHOW_ONEDAY_SALE_WARNING";

export interface HandleShowOnedaySaleWarning {
  type: typeof HANDLE_SHOW_ONEDAY_SALE_WARNING;
  payload: {
    formData: any;
  };
}


export const HANDLE_SHOW_ONEDAY_SALE_WARNING_RESOLVED = "HANDLE_SHOW_ONEDAY_SALE_WARNING_RESOLVED";

export interface HandleShowOnedaySaleWarningResolved {
  type: typeof HANDLE_SHOW_ONEDAY_SALE_WARNING_RESOLVED;
  payload: {
    formData: any;
  };
}

export const HANDLE_ADD_ONE_DAY_SALE_TO_DEAL_TRADEIN = "HANDLE_ADD_ONE_DAY_SALE_TO_DEAL_TRADEIN";

export interface HandleAddOneDaySaleToDealTradeIn {
    type: typeof HANDLE_ADD_ONE_DAY_SALE_TO_DEAL_TRADEIN;
    payload: { deal: any; callback: Function};
}

export const HANDLE_DELETE_ONE_DAY_SALE= "HANDLE_DELETE_ONE_DAY_SALE";

export interface HandleDeleteOneDaySale {
    type: typeof HANDLE_DELETE_ONE_DAY_SALE;
    payload: { id: any; callback: Function};
}

export type OneDaySaleDateActions =
    |HandleGetOneDaySaleDate
    |GetOneDaySaleDatePending
    |GetOneDaySaleDateResolved
    |GetOneDaySaleDateRejected
    |HandleGetOneDaySaleWorkbook
    |GetOneDaySaleWorkbookPending
    |GetOneDaySaleWorkbookResolved
    |GetOneDaySaleWorkbookRejected
    |HandleUpdateOneDaySaleDate
    |HandleCreateOneDaySaleDate
    |HandleGetOneDaySaleNotes
    |HandleSaveOneDaySaleNotes
    |HandleDeleteOneDaySaleDate
    |HandleGetAppraisalVehDetails
    |HandleGetAppraisalTrimUsingVin
    |HandleSelectedOneDaySaleTradeIn
    |HandleGetOneDaySaleAppraisal
    |GetOneDaySaleAppraisalPending
    |GetOneDaySaleAppraisalResolved
    |GetOneDaySaleAppraisalRejected
    |HandleGetOneDaySaleAppraisalById
    |GetOneDaySaleAppraisalByIdPending
    |GetOneDaySaleAppraisalByIdResolved
    |GetOneDaySaleAppraisalByIdRejected
    |HandleUpdateOneDaySaleAppraisal
    |HandleCreateOneDaySaleAppraisal
    | HandleGetOneDayAppraisalTable
    | HandleCreateOneDayAppraisalTableItem
    | GetOneDayAppraisalTablePending
    | GetOneDayAppraisalTableResolved
    | GetOneDayAppraisalTableRejected
    | HandleSearchOneDaySaleDealRecord
    | HandleCreateOneDaySaleDealRecord
    | HandleCreateAppraisalFormValue
    | HandleShowOnedaySaleWarning
    | HandleShowOnedaySaleWarningResolved
    | HandleAddOneDaySaleToDealTradeIn
    | HandleDeleteOneDaySale
